import i18n from '@/i18n';
import { CustomLabelsState, RootState } from '@/store/types';
import { Module, MutationTree } from 'vuex';
import DefaultLabels from './DefaultLabels';

const getDefaultState = (language: string): CustomLabelsState => {
    return { ...((DefaultLabels as any)[language] || DefaultLabels.en) };
};

export const state: CustomLabelsState = getDefaultState(i18n.locale);

export const mutations: MutationTree<CustomLabelsState> = {
    setCustomLabels(state, payload) {
        Object.assign(state, getDefaultState(i18n.locale));
        state.termsAndConditionsUrl = payload.data?.termsAndConditionsUrl?.value ?? state.termsAndConditionsUrl;
        state.termsAndConditionsText = payload.data?.termsAndConditionsText?.value ?? state.termsAndConditionsText;
        state.termsAndConditionsType = payload.data?.termsAndConditionsType?.value ?? state.termsAndConditionsType;
        state.privacyPolicyUrl = payload.data?.privacyPolicyUrl?.value ?? state.privacyPolicyUrl;
        state.portalTitle = payload.data?.portalTitle?.value ?? state.portalTitle;
        state.instanceTitle = payload.instanceTitle ?? payload.instanceId;
        state.homePageText = payload.data?.homePageText?.value ?? state.homePageText;
        state.createGrievanceTitle = payload.data?.createGrievanceTitle?.value ?? state.createGrievanceTitle;
        state.createGrievanceText = payload.data?.createGrievanceText?.value ?? state.createGrievanceText;
        state.footerText = payload.data?.footerText?.value ?? state.footerText;
        state.grievanceFollowUpAuthor = payload.data?.grievanceFollowUpAuthor?.value ?? state.grievanceFollowUpAuthor;
        state.addFollowUpModalInfo = payload.data?.addfollowupmodalinfo?.value ?? state.addFollowUpModalInfo;
        state.accessGrievanceBtn = payload.data?.accessGrievanceBtn?.value ?? state.accessGrievanceBtn;
        state.accessGrievanceTitle = payload.data?.accessGrievanceTitle?.value ?? state.accessGrievanceTitle;
        state.accessGrievanceInfo = payload.data?.accessGrievanceInfo?.value ?? state.accessGrievanceInfo;
        state.grievanceRefNo = payload.data?.grievanceRefNo?.value ?? state.grievanceRefNo ?? state.grievanceRefNo;
        state.originalGrievance = payload.data?.originalGrievance?.value ?? state.originalGrievance;
        state.grievanceNumberPlaceholder =
            payload.data?.grievanceNumberPlaceholder?.value ?? state.grievanceNumberPlaceholder;
        state.forgotPasswordGrievanceText =
            payload.data?.forgotPasswordGrievanceText?.value ?? state.forgotPasswordGrievanceText;
        state.grievanceDescriptionPlaceholder =
            payload.data?.grievanceDescriptionPlaceholder?.value ?? state.grievanceDescriptionPlaceholder;
        state.detailsPlaceholder = payload.data?.detailsPlaceholder?.value ?? state.detailsPlaceholder;
        state.grievanceConfirmSuccessText =
            payload.data?.grievanceConfirmSuccessText?.value ?? state.grievanceConfirmSuccessText;
        state.grievanceConfirmInfoText =
            payload.data?.grievanceConfirmInfoText?.value ?? state.grievanceConfirmInfoText;
        state.grievanceConfirmSubmitPasswordSuccessText =
            payload.data?.grievanceConfirmSubmitPasswordSuccessText?.value ??
            state.grievanceConfirmSubmitPasswordSuccessText;
        state.grievanceConfirmFollowUp =
            payload.data?.grievanceConfirmFollowUp?.value ?? state.grievanceConfirmFollowUp;
        state.viewInitialGrievance = payload.data?.viewInitialGrievance?.value ?? state.viewInitialGrievance;
        state.viewGrievance = payload.data?.viewGrievance?.value ?? state.viewGrievance;
        state.claimant = payload.data?.claimant?.value ?? state.claimant;
        state.customTermsAndConditions = payload.data?.customTermsAndConditions?.value;
    },
};

const CustomLabelsStore: Module<CustomLabelsState, RootState> = {
    namespaced: true,
    state,
    mutations,
};

export default CustomLabelsStore;
